export const LABEL = 'The answer is case sensitive';
export const MESSAGE = "When enabled, the casing of the student's answer is important. For example, answering 'lyon' is incorrect if the expected answer is 'Lyon'.";
